import React from "react"
import QuestionsCard from "./QuestionCard"
import { nanoid } from "nanoid"
import Submit from "./Submit"
import Welcome from "./Welcome"

export default function Main() {


    const [apiData, setApiData] = React.useState()



    React.useEffect(() => {
        fetch("https://opentdb.com/api.php?amount=5")
            .then(res => res.json())
            .then(data => {
                const dataResult = data.results;
                setApiData(() => dataResult.map(ques => {
                    const choices = ques.incorrect_answers.flat()
                    const randomNum = Math.trunc(Math.random() * choices.length)
                    const tempNum = choices[randomNum]

                    choices[randomNum] = ques.correct_answer
                    choices.push(tempNum)
                    console.log(choices, tempNum)

                    // choices.push(tempNum)
                    console.log(randomNum)
                    return {
                        ...ques,
                        btnChoices: choices
                    }
                }))
            })

    }, [])

    console.log(apiData)
    // Logic
    // Creating isHeld property


    function handleClick(event, incomeQuestion) {

        const currentQuestionCard = apiData.find(el => {
            return el.question === incomeQuestion
        })

        let currentBtn = event.target.textContent
        console.log(currentQuestionCard)
        const checkTheAnswer = currentQuestionCard.correct_answer === event.target.textContent

        setApiData(preValue => preValue.map(ques => {
            const check = ques.question === incomeQuestion
            return {
                ...ques,
                selectedChoice: check ? currentBtn : ques.selectedChoice

            }
        }))
    }




    const questionArr = apiData && apiData.map(card => {
        return <div key={nanoid()} className="quiz-holder">
            <QuestionsCard
                question={card.question}
                correctAns={card.correct_answer}
                incorrectAns={card.incorrect_answers}
                btnChoices={card.btnChoices}
                toggle={handleClick}
                selectedChoice={card.selectedChoice}
                allProps={card}
            />
        </div>
    })


    function onSubmit(event) {
        const checkAllChoiceSelected = apiData.every(ques => {
            return ques.selectedChoice ? true : false
        })
        let score = 0;
        if (event.target.textContent === "Play Again") window.location.reload();
        if (!checkAllChoiceSelected) return

        apiData.forEach(ques => {
            if (ques.correct_answer === ques.selectedChoice) {
                score++
            }
        })

        setApiData(preValue => {
            return preValue.map(ques => {
                return {
                    ...ques,
                    isSubmitted: true,
                    isCorrect: ques.correct_answer === ques.selectedChoice ? true : false,
                    score: score
                }
            })
        })

    }

    function welcomeBtn(e) {
        e.target.closest(".welcome-holder").style.display = "none"
        document.querySelector("body").style.overflow = "scroll"
        console.log(e.target.closest("body"))
    }
    return <div>
        <Welcome onClick={welcomeBtn} />
        <main>
            {questionArr}
            {apiData && <Submit apiData={apiData} onClick={onSubmit} />}

        </main>
    </div>
}